// -------------------------------------
//   SlickSlider
// -------------------------------------

$(document).ready(function () {
    var time = 2;
    var $bar,
    $slick,
    isPause,
    tick,
    percentTime;

    $slick = $('#slick-banner');

    $slick.slick({
        fade: false,
        arrows: true,
        dots: true,
        adaptiveHeight: true,
        pauseOnHover: true,
    });

    $bar = $('.slider-progress .progress');

    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        isPause = false;
        tick = setInterval(interval, 30);
    }

    function interval() {
        if (isPause === false) {
            percentTime += 1 / (time + 0.1);
            $bar.css({
                width: percentTime + "%"
            });
            if (percentTime >= 100) {
                $slick.slick('slickNext');
                startProgressbar();
            }
        }
    }

    function resetProgressbar() {
        $bar.css({
            width: 0 + '%'
        });
        clearTimeout(tick);
    }

    startProgressbar();

    $slick.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        startProgressbar();
    });

    $slick.on("mouseenter", function(){
        isPause = true;
    }).on("mouseleave", function(){
        isPause = false;
    })

    $('#slick-equipe').slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: false,
        lazyLoad: 'progressive',
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                }
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
});

//# sourceMappingURL=data:application/json;charset=utf8;base64,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
